import { render, staticRenderFns } from "./EmojiList.vue?vue&type=template&id=74f9a54a&scoped=true"
import script from "./EmojiList.vue?vue&type=script&lang=js"
export * from "./EmojiList.vue?vue&type=script&lang=js"
import style0 from "./EmojiList.vue?vue&type=style&index=0&id=74f9a54a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f9a54a",
  null
  
)

export default component.exports